import { render, staticRenderFns } from "./knowledgeQAhome.vue?vue&type=template&id=3c1e9bf0&scoped=true&"
import script from "./knowledgeQAhome.vue?vue&type=script&lang=js&"
export * from "./knowledgeQAhome.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeQAhome.vue?vue&type=style&index=0&id=3c1e9bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1e9bf0",
  null
  
)

export default component.exports